module.exports = __webpack_public_path__ + "static/Data Analytics-4273735e95cf67710e7e2c18b3773db6.png";